module.exports = __webpack_public_path__ + "./images/26a8e0fce3408b03c0bd905e6426180f.webp";